import React from 'react';
import CloseIcon from '../../../assets/book3.svg';
const SideBar = () => {
  return (
    <div className="flex p-2">
      <div className="bg-[#F4F6F8] h-[34px] w-full flex rounded items-center px-3 cursor-pointer ">
        <img src={CloseIcon} alt="upload" className="w-[16px] h-[16px]" />
        <span className="ml-1 text-[#009DFF]">本项目</span>
      </div>
    </div>
  );
};

export default SideBar;
